import { render } from "./SelecionarFiltroPeriodoMovimentoConta.vue?vue&type=template&id=6de52f70&ts=true"
import script from "./SelecionarFiltroPeriodoMovimentoConta.vue?vue&type=script&lang=ts"
export * from "./SelecionarFiltroPeriodoMovimentoConta.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__